import axios from "axios";

const getTransactions = async (formdetails, page, records) => {
  const formdata = {
    filters: formdetails,
    page: page,
    records: records,
  };
  const response = await axios.post(
    "/api/transactionMembership/get-transactions",
    formdata
  );
  return response.data;
};
const getTotalTransactions = async (formdata) => {
  const response = await axios.post(
    "/api/transactionMembership/get-total-transactions",
    { filters: formdata }
  );
  return response.data;
};

export default {
  getTransactions,
  getTotalTransactions,
};
